import { HOST_URL } from '../config'
import { HttpStatus } from '../constants/http-status.enum'
import type { ApiResponse } from './index'
import type { IMachine } from './0x0001/machine'

export type IClientUID = string

export interface IClientData {
    id: IClientUID
    mac: string
    remoteAddress: string
    createdAt: number
    machine?: IMachine
    phone?: IPhoneIntroduction
    model: ClientModel
    phyDebugger: boolean
}

export enum ClientModel {
    Unknown = 0x0000,
    Standard = 0x0001,
    LTI525S = 0x0002,
    SYRUP_TOWER = 0x0003,
    FILTER_FILLER = 0x0004,
    LTSP101 = 0x0005,
    LTCB220 = 0x0006,
    LTSP70 = 0x0007,
    LTSP175 = 0x0008,
    LTCB226 = 0x0009,
}

export interface IPhoneIntroduction {
    deviceName: string
    model: string
    systemName: string
    systemVersion: string
}

export async function getClients(): Promise<ApiResponse<IClientData[]>> {
    const response = await fetch(`${HOST_URL}clients`, { credentials: 'include' })
    const result = (await response.json()) as ApiResponse<IClientData[]>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}

export async function getClientById(id: IClientUID): Promise<ApiResponse<IClientData>> {
    const response = await fetch(`${HOST_URL}clients/${id}`, { credentials: 'include' })
    const result = (await response.json()) as ApiResponse<IClientData>
    if (response.status !== HttpStatus.Ok) throw new Error(result.message)
    return result
}
